// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21yOH","newExpiryDate":"styles_newExpiryDate__116OS","footer":"styles_footer__2G-C6"};